export const SANDBOX_DIFF_ACCESS_QUERY_PREFIX = ["sandboxDiffAccess"] as const;
export const sandboxDiffAccessQueryKey = (sessionId: string) =>
  [...SANDBOX_DIFF_ACCESS_QUERY_PREFIX, sessionId] as const;

/** By session id: how many times its sandboxes or PRs changed while this page was open. */
const generations = new Map<string, number>();

/** Read as a session payload's request starts, and handed back with the payload. */
export function payloadDiffAccessGeneration(sessionId: string): number {
  return generations.get(sessionId) ?? 0;
}

export function bumpPayloadDiffAccessGeneration(sessionId: string): void {
  generations.set(sessionId, payloadDiffAccessGeneration(sessionId) + 1);
}
